import { createGlobalStyle } from 'styled-components';
import Fonts from './fonts';
import FontStyles from './FontStyles';
import BaseStyles from './BaseStyles';
import TransitionStyles from './TransitionStyles';
import PrismStyles from './PrismStyles';

const GlobalStyleLight = createGlobalStyle`
  ${Fonts};

  ${FontStyles};

  :root {
    --john-bg-intense:rgb(182, 200, 255);
    --john-bg-moderate: #e6f1ff;
    --john-overlay:rgb(184, 203, 255);
    --john-bg-mild:rgb(199, 211, 248);
    --john-bg-mildest: #ccd6f6;
    --john-bg-shadow: rgba(126, 146, 176, 0.7);
    --john-text-moderate: #0a192f;
    --john-text-mild: #172a45;
    --john-text-mildest: #303c55;
    --john-text-intense: #020c1b;
    --john-text-pretty: #5050bb;
    --john-photo-overlay:rgb(157, 157, 255);
    --john-text-pretty-shadow: rgba(80, 80, 187, 0.1);
    --john-nav-color: rgba(230, 241, 255, 0.85);
    --john-title-overlay: rgba(188, 211, 241, 0.7);
    --john-bg-overlay: #0a192f;
    --john-tint-color: 230, 241, 255;

    --border-radius: 4px;
    --nav-height: 100px;
    --nav-scroll-height: 70px;

    --tab-height: 42px;
    --tab-width: 200px;
    &:lang(ko) {
      --tab-width: 120px;
    }
    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    --hamburger-width: 30px;

    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out, transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }

  ${BaseStyles};

  ${TransitionStyles};

  ${PrismStyles};
`;

export default GlobalStyleLight;
